import React from 'react';
import AppNav from './AppNav';
import CssBaseline from '@material-ui/core/CssBaseline';
import SuccessMsg from './SuccessMsg';

export default props => (
  <React.Fragment>
    <CssBaseline />
    <AppNav toggleTheme={props.toggleTheme} user={props.user} path={props.path}/>
    {props.children}
    <SuccessMsg />
  </React.Fragment>
);
